import { Form, Modal, Select } from "antd"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"

import { type FileItem } from "../types/file-item.types.ts"
import { type FolderListItem } from "../types/folder.types.ts"

interface MoveFileModalProps {
  files: FileItem[]
  folders: FolderListItem[]
  onClose: () => void
  onSubmit: (folderId: string | null) => Promise<void>
}

export function MoveFileModal({
  files,
  folders,
  onClose,
  onSubmit
}: MoveFileModalProps) {
  const { t } = useTranslation()
  const [folderId, setFolderId] = useState<string | null>(
    files.length === 1 ? files[0].folderId : null
  )
  const [submitting, setSubmitting] = useState(false)

  const title =
    files.length === 1
      ? t("files.move.title", { name: files[0].name })
      : t("files.move.titleMany", {
          count: files.length
        })

  const handleOk = async () => {
    setSubmitting(true)
    try {
      await onSubmit(folderId)
      onClose()
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Modal
      open
      title={title}
      onCancel={onClose}
      onOk={() => void handleOk()}
      confirmLoading={submitting}
      okText={t("files.move.confirm")}
    >
      <Form layout="vertical">
        <Form.Item label={t("files.move.destination")}>
          <Select<string | null>
            value={folderId}
            onChange={setFolderId}
            options={[
              { value: null, label: t("files.move.root") },
              ...folders.map((folder) => ({
                value: folder.id,
                label: folder.name
              }))
            ]}
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}
